module.exports = __webpack_public_path__ + "img/yyfy.65f94973.png";